<template>
  <section class="screen">

    <div class="welcome">
        <div class="welcome__logo">LuciDent<br><span class="light-font">admin</span></div>
        <div class="welcome__actions">
            <div class="welcome__actions">
                <div @click="registerScreen = true ; loginScreen = false" :class="{'welcome__active-button' : registerScreen}" class="welcome__button">Sign up</div>
                <div @click="loginScreen = true ; registerScreen = false" :class="{'welcome__active-button' : loginScreen}" class="welcome__button">Sign in</div>
            </div>
        </div>
    </div>
    <div v-if="loginScreen" class="login">
        <input type="email" placeholder="email" v-model="email">
        <input type="password" placeholder="password" v-model="password">
        <div class="login__button" @click="login($event)">Sign in</div>
    </div>
    <div v-if="registerScreen" class="login">
        <input type="text" placeholder="name" v-model="name">
        <input type="email" placeholder="email" v-model="email">
        <input type="password" placeholder="password" v-model="password">
        <div class="login__button" @click="register">Register</div>
    </div>





  </section>

</template>
<script>
import firebase from 'firebase'
import { firestore } from '../main'
import { page } from 'vue-analytics'
import { mapMutations, mapGetters } from 'vuex'


export default {
  name: 'register',
  data: function () {
    return {
      registerScreen: true,
      loginScreen: false,
      email: '',
      password: '',
      name: '',
      displayName: '',
      currentUser: '',
      photoURL: '',
      uid: '',
      errors: '',
      verifiedPassword: ''
    }
  },
    computed: {
    ...mapGetters([
      'loggedIn',
      'user'
    ])
  },
  methods: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ]),
    getLogs: function(event) {

    },
    login: function (e) {
        let payload = {
          event: e,
          email: this.email,
          password: this.password
        }
        this.$store.commit('logIn', payload);
    },
    checkForm: function (e) {
      if (this.name && this.email) {
        return true
      }

      this.errors = []

      if (!this.name) {
        this.errors.push('Full name required.')
      }
      if (!this.email) {
        this.errors.push('email is required.')
      }
      if (!this.password) {
        this.errors.push('passwords cannot be empty.')
      }
      if (!this.password.length < 6) {
        this.errors.push('password must be at least 6 characters')
      }
      if (this.password !== this.verifiedPassword) {
        this.errors.push('passwords must match.')
      }

      e.preventDefault()
    },
    register: function (e) {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then((result) => {
          const createdAt = new Date()
          this.currentUser = firebase.auth().currentUser.email
          this.user.uid = firebase.auth().currentUser.uid
          this.user.photoURL = firebase.auth().currentUser.photoURL
          this.user.displayName = this.name
          if (firebase.auth().currentUser) {
            firestore.collection('provider').doc(this.user.uid).set({
              uid: this.user.uid,
              displayName: this.user.displayName,
              photoURL: this.user.photoURL,
              email: this.currentUser,
              createdAt: createdAt,
            }, {merge: true})
          }
        })
        .then((result) => {
          this.$router.push('/timeline')
        })
        .catch(error => {
          alert(error)
        })
      e.preventDefault()
    },
    googleRegister: function () {
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider)
        .then((result) => {
          const createdAt = new Date()

          this.currentUser = firebase.auth().currentUser.email
          this.user.uid = firebase.auth().currentUser.uid
          this.user.displayName = firebase.auth().currentUser.displayName
          this.user.photoURL = firebase.auth().currentUser.photoURL

          if (firebase.auth().currentUser) {
            firestore.collection('provider').doc(this.user.uid).set({
              uid: this.user.uid,
              photoURL: this.user.photoURL,
              displayName: this.user.displayName,
              email: this.currentUser,
              createdAt: createdAt
            }, {merge: true})
          }
        })
        .then((result) => {
          this.$router.push('/timeline')
        })
    }
  }
}

</script>


<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;



.screen {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 50px;
    width: 100%;
    height: auto;
    .welcome {
        height: 300px;
        width: 100%;
        // background-image: linear-gradient(to bottom right, $brandColor, $brandColorTwo);
        background-color: #232535;
        color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &__logo {
            font-size: 3em;
            font-weight: 800;
            color: #fff;
            .light-font {
              font-weight: 100 !important;
            }
        }
        &__actions {
            position: absolute;
            bottom: 0;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 50px;
            border-top: 1px solid #ddd;
        }
        &__button {
            width: 50%;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 12px;
            color: #ddd;
        }
        &__active-button {
            color: #fff;
        }
    }
    .login {
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        input {
            border: none;
            border-bottom: 1px solid #ddd;
            width: 300px;
            font-size: 18px;
            margin: 10px 0;
            padding: 10px 5px;
            outline: none;
            color: #777;
            &::placeholder {
                color: #ddd;
            }
        }
        &__button {
            background-color: $accentColor;
            color: #fff;
            width: 130px;
            margin: 1em 0;
            padding: 10px;
            border-radius: 5px;
            
        }
    }
}

  
</style>



// WEBPACK FOOTER //
// src/components/Register.vue